import { string, shape, bool } from 'prop-types';

const connectionStatusActivityShape = shape({
  newVisibilityAppStatus: string,
  initiatorName: string,
  isAutomated: bool,
});

export default connectionStatusActivityShape;
